import Reveal from "@/components/base/Reveal";
import SectionLabel from "@/components/base/SectionLabel";

export default function About() {
  return (
    <section id="ocean" className="relative bg-background-50 py-16 md:py-20 lg:py-24">
      <span
        className="pointer-events-none absolute inset-x-0 top-0 mx-auto h-px w-2/3 bg-gradient-to-r from-transparent via-accent-500/25 to-transparent"
        aria-hidden="true"
      />
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <SectionLabel>Sobre a Ocean</SectionLabel>
            <h2 className="mt-5 max-w-xl font-heading text-3xl font-medium leading-[1.15] text-foreground-950 md:text-5xl">
              Comércio conectado às oportunidades do mercado.
            </h2>

            <div className="mt-8 max-w-[660px] space-y-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              <p>
                A{" "}
                <strong className="font-medium text-foreground-800">OCEAN COMPANHIA DE COMÉRCIO LTDA</strong> atua na
                importação e comercialização de produtos destinados ao mercado nacional.
              </p>
              <p>
                Trabalhamos com produtos de origem internacional selecionados de acordo com as necessidades e demandas
                do mercado brasileiro.
              </p>
              <p>
                Nossos produtos são importados e posteriormente comercializados em todo o território nacional,
                atendendo empresas de diferentes segmentos.
              </p>
            </div>

            <div className="mt-9 flex items-center gap-3">
              <span className="h-px w-10 bg-accent-500" />
              <span className="ocean-label text-[10px] text-foreground-600">Maceió · Alagoas · Brasil</span>
            </div>
          </Reveal>

          <Reveal delay={120} className="lg:justify-self-end">
            <div className="relative w-full max-w-[560px]">
              <div className="absolute -left-3 -top-3 hidden h-24 w-24 border-l border-t border-accent-500/50 lg:block" />
              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20stacked%20international%20shipping%20containers%20and%20cargo%20cranes%20in%20cool%20blue%20tones%20with%20soft%20overcast%20light%2C%20premium%20corporate%20logistics%20imagery%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=1000&height=1250&seq=ocean-about-operation&orientation=portrait"
                  alt="Contêineres empilhados em terminal logístico internacional"
                  title="Operação de importação e logística"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 hidden h-24 w-24 border-b border-r border-accent-500/50 lg:block" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}